import { Link } from '@tanstack/react-router';
import type { EventHistoryDTO } from '@uturn/api/v1';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
	Icon,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';
import { EventType } from './events-feed.types';
import { getIconProps } from './events-feed.utils';

export function EventsFeedType({
	eventType,
}: {
	eventType: string | undefined;
}) {
	const iconProps = getIconProps(
		EventType[eventType as keyof typeof EventType],
	);
	return (
		<div>
			<span
				className={`${iconProps.eventColor.backgroundColor} flex size-8 items-center justify-center rounded-full`}
			>
				<Icon
					icon={iconProps.name}
					className={`size-4 ${iconProps.eventColor.iconColor}`}
					aria-hidden="true"
				/>
			</span>
		</div>
	);
}

export function EventsFeedItem({
	shipmentNumber,
	createdOn,
	eventType,
	description,
	userName,
	initiatedBy,
}: EventHistoryDTO) {
	const createdOnDate = new Date(createdOn ?? '');
	const { t, i18n } = useTranslation();

	const time = `${createdOnDate.toLocaleTimeString(i18n.language, {
		minute: '2-digit',
		hour: '2-digit',
	})}`;

	return (
		<div className="w-full">
			<div className="flex justify-between gap-x-4">
				<div className="py-0.5 text-sm font-bold leading-6">
					{shipmentNumber !== undefined && (
						<Link to="/shipments/$shipmentNumber" params={{ shipmentNumber }}>
							{shipmentNumber}
						</Link>
					)}
				</div>
				<div className="text-secondary-600 flex-none py-0.5 text-sm leading-6">
					<span>{time}</span>
				</div>
			</div>
			{description ? (
				<Accordion type="single" collapsible>
					<AccordionItem value="item" className="border-none">
						<AccordionTrigger className="leading-0 items-start text-left text-sm font-normal">
							{`${eventType} ${t(
								'general.event_feed.author',
								'by {{ name }} via {{ source }}',
								{
									name: userName,
									source: initiatedBy,
								},
							)}`}
						</AccordionTrigger>
						<AccordionContent className="text-muted-foreground text-sm">
							{description}
						</AccordionContent>
					</AccordionItem>
				</Accordion>
			) : (
				<div className="w-4/5 text-sm leading-6">
					<span className="mr-1">{eventType}</span>
					<span>
						{t('general.event_feed.author', 'by {{ name }} via {{ source }}', {
							name: userName,
							source: initiatedBy,
						})}
					</span>
				</div>
			)}
		</div>
	);
}
